import React from 'react';
import { times } from 'lodash';
import { HtmlTable } from '../../../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Shimmer } from '../../../../../../../../CommonComponents/OPL/Shimmer/Shimmer';

export const LoadingTable = () => {
  return (
    <HtmlTable>
      <table style={{ tableLayout: 'fixed' }}>
        <colgroup>
          <col width="20%" />
          <col width="10%" />
          <col width="23%" />
          <col width="23%" />
          <col width="24%" />
        </colgroup>

        <thead>
          <tr>
            {times(5).map(key => (
              <th key={key}>&nbsp;</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {times(4).map(key => (
            <tr key={key}>
              {times(5).map(cellKey => (
                <td key={cellKey}>
                  <Shimmer width="100%" height={24} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </HtmlTable>
  );
};
